import { IS_LOADING, SET_DATA_ID, SET_DATA_ITEM, SET_DATA_LIST, SET_ERROR, SET_SUCCESS, SET_TOTAL } from "@/store/Crud/functions/mutations";
export function SET_PREVIEW(state, preview) {
    state.preview = preview;
}
export default {
    IS_LOADING,
    SET_ERROR,
    SET_SUCCESS,
    SET_DATA_ITEM,
    SET_DATA_LIST,
    SET_TOTAL,
    SET_DATA_ID,
    SET_PREVIEW,
};
